import React from "react";

interface PropTypes {
  classNames?: string;
  children?: React.ReactNode;
}
export default function Column({ classNames, children }: PropTypes) {
  return <div className={`${classNames || ""}`}>{children}</div>;
}
